import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import AOS from "aos";
import "aos/dist/aos.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ReadyToStartProject from "../components/ReadyToStartProject";

const SocialReseau = () => {
  const [showMore, setShowMore] = useState({});

  useEffect(() => {
    AOS.init({
      duration: 1000, // Durée de l'animation en ms
      easing: "ease-in-out", // Type d'animation
    });
  }, []);

  const toggleShowMore = (index) => {
    setShowMore((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const scrollToElement = (text) => {
    document.getElementById(text).scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-gradient-to-b from-gray-900 to-gray-700 min-h-screen text-white">
      {/* Helmet pour SEO */}
      <Helmet>
        <title>
          Stratégies de Réseaux Sociaux Performantes | Votre Société
        </title>
        <meta
          name="description"
          content="Boostez votre présence en ligne avec des stratégies de réseaux sociaux adaptées à vos besoins. Découvrez nos services et nos tarifs avantageux."
        />
        <meta
          name="keywords"
          content="réseaux sociaux, stratégie, marketing digital, SEO, publicité sociale"
        />
      </Helmet>

      <Navbar />

      {/* Section d'introduction avec image de fond */}
      <div
        className="h-screen bg-cover bg-center relative"
        style={{ backgroundImage: `url('/images/social.jpg')` }}
      >
        <div className="flex items-center justify-center h-full bg-black bg-opacity-60">
          <div className="text-center max-w-3xl" data-aos="fade-up">
            <h1 className="text-5xl font-extrabold mb-6">
              Stratégies de Réseaux Sociaux Performantes
            </h1>
            <p className="text-2xl mb-6">
              Boostez votre présence en ligne avec des stratégies adaptées à vos
              besoins.
            </p>
            <p className="text-lg mb-8">
              Exploitez la puissance des réseaux sociaux pour engager votre
              audience et faire croître votre marque.
            </p>
            <a
              href="#"
              onClick={() => scrollToElement("why-social")}
              className="mt-4 px-8 py-3 bg-red-600 text-white text-lg font-semibold rounded-md shadow-lg hover:bg-red-700 transition duration-300"
            >
              Découvrir nos services
            </a>
          </div>
        </div>
        <div
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white cursor-pointer animate-bounce"
          onClick={() => scrollToElement("why-social")}
        >
          <i className="fas fa-chevron-down fa-2x"></i>
        </div>
      </div>

      {/* Section Pourquoi les Réseaux Sociaux */}
      <div
        id="why-social"
        className="py-16 px-6 md:px-12 lg:px-24 bg-gray-800"
        data-aos="fade-up"
      >
        <h2 className="text-4xl font-bold mb-8 text-center">
          Pourquoi les Réseaux Sociaux ?
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <h3 className="text-2xl font-semibold mb-4">
              Augmentez Votre Visibilité
            </h3>
            <p className="text-lg mb-4">
              Les réseaux sociaux sont cruciaux pour accroître la visibilité de
              votre marque et toucher une audience plus large.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-4">
              Engagement Client Amélioré
            </h3>
            <p className="text-lg mb-4">
              Renforcez l'engagement des clients grâce à une interaction
              continue, favorisant ainsi la fidélité à votre marque.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-4">
              Mesure des Performances
            </h3>
            <p className="text-lg mb-4">
              Analysez les résultats de vos campagnes en temps réel pour
              optimiser votre stratégie et maximiser votre ROI.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-semibold mb-4">
              Flexibilité et Réactivité
            </h3>
            <p className="text-lg mb-4">
              Adaptez rapidement vos messages aux tendances et aux besoins de
              votre audience grâce à la flexibilité des réseaux sociaux.
            </p>
          </div>
        </div>
      </div>

      {/* Section de Services */}
      <div
        className="py-16 bg-gray-900 px-6 md:px-12 lg:px-24"
        data-aos="fade-up"
      >
        <h2 className="text-4xl font-bold mb-8 text-center text-yellow-500">
          Nos Services en Réseaux Sociaux
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div
            className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
            data-aos="fade-up"
          >
            <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
              Gestion de Campagnes Publicitaires
            </h3>
            <p className="text-lg mb-4">
              Optimisez vos campagnes sur les réseaux sociaux pour maximiser vos
              résultats avec un budget efficace.
            </p>
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                showMore[0] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-lg mb-4">
                Nous vous aidons à cibler les bonnes audiences, à tester
                différents formats d'annonces, et à ajuster les campagnes en
                temps réel pour obtenir les meilleurs résultats possibles.
              </p>
            </div>
            <button
              onClick={() => toggleShowMore(0)}
              className="text-blue-500 hover:text-blue-600 transition duration-300"
            >
              {showMore[0] ? "Lire moins" : "Lire plus"} &rarr;
            </button>
          </div>

          <div
            className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
            data-aos="fade-up"
          >
            <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
              Création de Contenu Visuel
            </h3>
            <p className="text-lg mb-4">
              Créez des visuels accrocheurs qui attirent l'attention de votre
              audience et renforcent votre message.
            </p>
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                showMore[1] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-lg mb-4">
                Nous concevons des images, des vidéos et des infographies sur
                mesure, adaptées à votre marque et optimisées pour les
                plateformes de réseaux sociaux que vous utilisez.
              </p>
            </div>
            <button
              onClick={() => toggleShowMore(1)}
              className="text-blue-500 hover:text-blue-600 transition duration-300"
            >
              {showMore[1] ? "Lire moins" : "Lire plus"} &rarr;
            </button>
          </div>

          <div
            className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
            data-aos="fade-up"
          >
            <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
              Stratégie de Contenu
            </h3>
            <p className="text-lg mb-4">
              Développez une stratégie de contenu engageante pour maintenir
              l'intérêt de votre audience.
            </p>
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                showMore[2] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-lg mb-4">
                Nous vous aidons à planifier et à créer du contenu qui résonne
                avec votre audience cible, en tenant compte des tendances
                actuelles et des meilleures pratiques des réseaux sociaux.
              </p>
            </div>
            <button
              onClick={() => toggleShowMore(2)}
              className="text-blue-500 hover:text-blue-600 transition duration-300"
            >
              {showMore[2] ? "Lire moins" : "Lire plus"} &rarr;
            </button>
          </div>

          <div
            className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
            data-aos="fade-up"
          >
            <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
              Analyse et Reporting
            </h3>
            <p className="text-lg mb-4">
              Recevez des rapports détaillés pour comprendre les performances de
              vos campagnes.
            </p>
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                showMore[3] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-lg mb-4">
                Nos rapports incluent des analyses approfondies des métriques de
                performance clés, vous aidant à affiner vos stratégies pour des
                résultats encore meilleurs à l'avenir.
              </p>
            </div>
            <button
              onClick={() => toggleShowMore(3)}
              className="text-blue-500 hover:text-blue-600 transition duration-300"
            >
              {showMore[3] ? "Lire moins" : "Lire plus"} &rarr;
            </button>
          </div>

          <div
            className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
            data-aos="fade-up"
          >
            <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
              Gestion de la Communauté
            </h3>
            <p className="text-lg mb-4">
              Renforcez les relations avec vos clients et prospects grâce à une
              gestion active de la communauté.
            </p>
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                showMore[4] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-lg mb-4">
                Nous interagissons avec votre communauté en ligne, répondons aux
                commentaires et messages, et construisons une base de fans
                fidèles à votre marque.
              </p>
            </div>
            <button
              onClick={() => toggleShowMore(4)}
              className="text-blue-500 hover:text-blue-600 transition duration-300"
            >
              {showMore[4] ? "Lire moins" : "Lire plus"} &rarr;
            </button>
          </div>

          <div
            className="bg-gray-800 rounded-lg shadow-lg p-6 hover:shadow-2xl transition-shadow duration-300"
            data-aos="fade-up"
          >
            <h3 className="text-2xl font-semibold mb-4 text-yellow-300">
              Formation et Consultation
            </h3>
            <p className="text-lg mb-4">
              Formez vos équipes aux meilleures pratiques des réseaux sociaux
              pour des résultats optimaux.
            </p>
            <div
              className={`transition-all duration-500 ease-in-out overflow-hidden ${
                showMore[5] ? "max-h-screen opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-lg mb-4">
                Nous offrons des formations sur mesure et des consultations pour
                aider vos équipes à maîtriser les stratégies de réseaux sociaux
                les plus efficaces pour votre entreprise.
              </p>
            </div>
            <button
              onClick={() => toggleShowMore(5)}
              className="text-blue-500 hover:text-blue-600 transition duration-300"
            >
              {showMore[5] ? "Lire moins" : "Lire plus"} &rarr;
            </button>
          </div>
        </div>
      </div>

      {/* Section des Tarifs SEO */}
      <section
        data-aos="fade-up"
        id="pricing"
        className="py-20 bg-fixed bg-cover bg-center text-center"
        style={{
          backgroundAttachment: "fixed",
          backgroundPosition: "center",
        }}
      >
        <div className="bg-gradient-to-r from-gray-800 to-gray-900 py-16">
          <h2 className="text-5xl font-bold mb-16 text-yellow-400">
            Nos Tarifs Réseaux Sociaux Avantageux
          </h2>
          <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-4">
            {/* Plan de Base */}
            <div className="bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border-2 border-blue-500 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 p-8 relative flex flex-col">
              <div className="absolute top-0 left-0 bg-blue-500 text-white py-2 px-6 text-sm font-bold transform -translate-y-1/2 -translate-x-1/4 rotate-12">
                Populaire
              </div>
              <h3 className="text-2xl font-semibold mb-6 text-yellow-300">
                Forfait de Base
              </h3>
              <p className="text-5xl font-bold mb-6 text-white">€499</p>
              <ul className="text-left space-y-4">
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Audit SEO complet
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Optimisation de 5 pages
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Rapport mensuel détaillé
                </li>
              </ul>
              <a
                href="/contact"
                className="mt-auto px-8 py-3 bg-blue-500 text-white-800 font-semibold rounded-md shadow-lg hover:bg-yellow-500 transition duration-300"
              >
                Commencer
              </a>
            </div>
            {/* Plan Avancé */}
            <div className="bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border-2 border-yellow-500 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 p-8 relative flex flex-col">
              <div className="absolute top-0 left-0 bg-yellow-500 text-white py-2 px-6 text-sm font-bold transform -translate-y-1/2 -translate-x-1/4 rotate-12">
                Le Plus Populaire
              </div>
              <h3 className="text-2xl font-semibold mb-6 text-yellow-300">
                Forfait Avancé
              </h3>
              <p className="text-5xl font-bold mb-6 text-white">€999</p>
              <ul className="text-left space-y-4 mb-5">
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Audit SEO complet
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Optimisation de 15 pages
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Suivi des mots-clés
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Rapport hebdomadaire
                </li>
              </ul>
              <a
                href="/contact"
                className="mt-auto px-8 py-3 bg-yellow-500 text-white-800 font-semibold rounded-md shadow-lg hover:bg-yellow-500 transition duration-300"
              >
                Commencer
              </a>
            </div>
            {/* Plan Pro */}
            <div className="bg-gradient-to-br from-gray-700 via-gray-800 to-gray-900 border-2 border-red-500 rounded-lg shadow-lg hover:shadow-2xl transition-shadow duration-300 p-8 relative flex flex-col">
              <div className="absolute top-0 left-0 bg-red-500 text-white py-2 px-6 text-sm font-bold transform -translate-y-1/2 -translate-x-1/4 rotate-12">
                Exclusif
              </div>
              <h3 className="text-2xl font-semibold mb-6 text-yellow-300">
                Forfait Pro
              </h3>
              <p className="text-5xl font-bold mb-6 text-white">€1499</p>
              <ul className="text-left space-y-4">
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Audit SEO complet
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Optimisation de 30 pages
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Suivi avancé des mots-clés
                </li>
                <li>
                  <i className="fas fa-check-circle text-green-400 mr-2"></i>
                  Consultation SEO mensuelle
                </li>
              </ul>
              <a
                href="/contact"
                className="mt-auto px-8 py-3 bg-red-500 text-white-800 font-semibold rounded-md shadow-lg hover:bg-yellow-500 transition duration-300"
              >
                Commencer
              </a>
            </div>
          </div>
          <p className="mt-10 text-gray-400 text-center">
            Les tarifs indiqués sont standards et peuvent varier en fonction de
            vos besoins spécifiques. N’hésitez pas à nous contacter pour un
            devis personnalisé.
          </p>
        </div>
      </section>

      {/* Section Prêt à démarrer */}
      <div data-aos="fade-up">
        <ReadyToStartProject />
      </div>

      <Footer />
    </div>
  );
};

export default SocialReseau;
